module.exports = __webpack_public_path__ + "img/icon-email-success.81849e6b.svg";